/**
 * The one place the public URL lives, imported from both the browser (share
 * text) and Node (newsletter images) sides of the codebase.
 *
 * Placeholder until the Cloudflare Pages project exists and assigns a real
 * `*.pages.dev` subdomain — update this one line once that's known.
 */
export const SITE_URL = "https://path-puzzle.pages.dev";
